import { apiSlice } from "../../../slices/apiSlice";

export const dosptefaApiSlice = apiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getProjectsByClient: builder.mutation({
      query: (parameters) => ({
        url: `/Financix/Dosptefa/getProjectsByClient`,
        method: "GET",
        params: { ...parameters },
      }),
    }),
    getApplicableOffer: builder.query({
      query: (parameters) => ({
        url: `/Financix/Dosptefa/getApplicableOffer`,
        method: "GET",
        params: { ...parameters },
      }),
    }),
    assignProject: builder.mutation({
      query: (parameters) => ({
        url: `/Financix/Dosptefa/Projects`,
        method: "POST",
        body: parameters,
        headers: { Modulecima: "Financix" },
      }),
      invalidatesTags: ["Create"],
    }),
    getLiquidationDo: builder.query({
      query: (parameters) => ({
        url: `/Financix/Dosptefa/getLiquidationDo/${parameters.DOCNROXX}`,
        method: "GET",
        //Se llama tambien desde la tarea de Informacion Adicional (Ordtraxx): sin el header
        //sale con el modulo donde navega el usuario y en pruebas responde 404
        headers: { Modulecima: "Financix" },
      }),
    }),
    returnStatus: builder.mutation({
      query: (parameters) => ({
        url: `/Financix/Dosptefa/returnStatus/${parameters.DOCNROXX}`,
        method: "PUT",
        body: parameters,
      }),
      invalidatesTags: ["Create"],
    }),
    rejectProforma: builder.mutation({
      query: (parameters) => ({
        url: `/Financix/Dosptefa/rejectProforma/${parameters.DOCNROXX}`,
        method: "PUT",
        body: parameters,
      }),
      invalidatesTags: ["Create"],
    }),
    getConceptsById: builder.mutation({
      query: (parameters) => ({
        url: `/Financix/Dosptefa/getConceptsById`,
        method: "GET",
        params: parameters,
      }),
    }),
    storeManualBilling: builder.mutation({
      query: (parameters) => ({
        url: `/Financix/Dosptefa/manualBilling`,
        method: "POST",
        params: parameters,
      }),
      invalidatesTags: ["Create"],
    }),
    getColorStatus: builder.query({
      query: () => ({
        url: `/Financix/Dosptefa/getColorStatus`,
        method: "GET",
      }),
    }),
    getBillingClosureById: builder.query({
      query: (parameters) => ({
        url: `/Financix/Dosptefa/getBillingClosureById/${parameters.CLIIDXXX}`,
        method: "GET",
      }),
    }),
    getInvoiceProforma: builder.mutation({
      query: (parameters) => ({
        url: `/Intfinxx/getInvoiceProforma`,
        method: "GET",
        params: parameters,
        headers: { Modulecima: "Intfinxx" },
      }),
    }),
    writeInvoice: builder.mutation({
      query: (parameters) => ({
        url: `/Intfinxx/writeInvoice`,
        method: "POST",
        body: parameters,
        headers: { Modulecima: "Intfinxx" },
      }),
      invalidatesTags: ["Create"],
    }),
    getClientByPerfilDosptefa: builder.mutation({
      query: (parameters) => ({
        url: `/Financix/Dosptefa/getClientByPerfil`,
        method: "GET",
        params: parameters,
      }),
    }),
    getPreFilteredOperations: builder.query({
      query: (parameters) => ({
        url: `/Intfinxx/getPreFilteredOperations`,
        method: "GET",
        params: parameters,
        headers: { Modulecima: "Intfinxx" },
      }),
    }),
    getPreFilteredLevante: builder.query({
      query: (parameters) => ({
        url: `/Intfinxx/getPreFilteredLevante`,
        method: "GET",
        params: parameters,
        headers: { Modulecima: "Intfinxx" },
      }),
    }),
    generateDraft: builder.mutation({
      query: (parameters) => ({
        url: `/Intfinxx/generateDraft`,
        method: "POST",
        body: parameters,
        headers: { Modulecima: "Intfinxx" },
      }),
    }),
    generateBillingDocuments: builder.mutation({
      query: (parameters) => ({
        url: `/Intfinxx/generateBillingDocuments`,
        method: "POST",
        body: parameters,
        headers: { Modulecima: "Intfinxx" },
      }),
      invalidatesTags: ["Create"],
    }),
    getAdvanceClient: builder.mutation({
      query: (parameters) => ({
        url: `/Financix/Dosptefa/getAdvanceClient`,
        method: "GET",
        params: parameters,
      }),
    }),
    getRefundsClient: builder.mutation({
      query: (parameters) => ({
        url: `/Financix/Dosptefa/getRefundsClient`,
        method: "GET",
        params: parameters,
      }),
    }),
    getInvoicesClient: builder.mutation({
      query: (parameters) => ({
        url: `/Financix/Dosptefa/getInvoicesClient`,
        method: "GET",
        params: parameters,
      }),
    }),
    generateExcelProformas: builder.mutation({
      query: (parameters) => ({
        url: `/Financix/Dosptefa/generateExcelProformas`,
        method: "POST",
        body: parameters,
        headers: { Modulecima: "Financix" },
      }),
    }),
    getPdfInvoice: builder.query({
      query: (parameters) => ({
        url: `/Intfinxx/getPdfInvoice`,
        method: "GET",
        params: parameters,
        headers: { Modulecima: "Intfinxx" },
      }),
    }),
    getProjectsByOperations: builder.mutation({
      query: (parameters) => ({
        url: `/Financix/Dosptefa/getProjectsByOperations`,
        method: "GET",
        params: parameters,
      }),
    }),
    getRatesByOperation: builder.mutation({
      query: (parameters) => ({
        url: `/Intfinxx/getRatesByOperation`,
        method: "GET",
        params: parameters,
        headers: { Modulecima: "Intfinxx" },
      }),
    }),
    getStatusInvoice: builder.query({
      query: (parameters) => ({
        url: `/Intfinxx/getStatusInvoice`,
        method: "GET",
        params: parameters,
        headers: { Modulecima: "Intfinxx" },
      }),
    }),
    getOperationsByProforma: builder.query({
      query: (parameters) => ({
        url: `/Financix/Dosptefa/getOperationsByProforma`,
        method: "GET",
        params: parameters,
      }),
    }),
    getTotalAdvance: builder.mutation({
      query: (parameters) => ({
        url: `/Financix/Ctrlcupo/getTotalAdvance`,
        method: "GET",
        params: parameters,
        headers: { Modulecima: "Financix" },
      }),
    }),
    getDoGlobalByClient: builder.query({
      query: (parameters) => ({
        url: `/Financix/Dosptefa/getDoGlobalByClient`,
        method: "GET",
        params: parameters,
        headers: { Modulecima: "Financix" },
      }),
    }),
    getTypeAdvanceClient: builder.query({
      query: (parameters) => ({
        url: `/Financix/Dosptefa/getTypeAdvanceClient`,
        method: "GET",
        params: parameters,
      }),
    }),
    getTaskAdvanceDo: builder.mutation({
      query: (parameters) => ({
        url: `/Financix/Dosptefa/getTaskAdvanceDo`,
        method: "GET",
        params: parameters,
      }),
    }),
    generateDraftTask: builder.mutation({
      query: (parameters) => ({
        url: `/Intfinxx/generateDraftTask`,
        method: "POST",
        body: parameters,
        headers: { Modulecima: "Intfinxx" },
      }),
    }),
    getLiquidations: builder.mutation({
      query: (parameters) => ({
        url: `/Financix/Dosptefa/getLiquidations`,
        method: "GET",
        params: parameters,
      }),
    }),
    getInformationBavaria: builder.query({
      query: (parameters) => ({
        url: `/Financix/Dosptefa/getInformationBavaria`,
        method: "GET",
        params: parameters,
      }),
    }),
    getBillingCondition: builder.query({
      query: (parameters) => ({
        url: `/Intfinxx/getBillingCondition`,
        method: "GET",
        params: parameters,
        headers: { Modulecima: "Intfinxx" },
      }),
    }),
    generateRefundIncomeDraft: builder.mutation({
      query: (parameters) => ({
        url: `/Intfinxx/generateRefundIncomeDraft`,
        method: "POST",
        body: parameters,
        headers: { Modulecima: "Intfinxx" },
      }),
    }),
    generateRefundIncome: builder.mutation({
      query: (parameters) => ({
        url: `/Intfinxx/generateRefundIncome`,
        method: "POST",
        body: parameters,
        headers: { Modulecima: "Intfinxx" },
      }),
      invalidatesTags: ["Create"],
    }),
    getThirtsByOperations: builder.query({
      query: (params) => ({
        url: `/Intfinxx/getThirtsByOperations`,
        params,
        headers: { Modulecima: "Intfinxx" },
      }),
    }),
    getIsAvailableToGenerateInvoice: builder.query({
      query: (params) => ({
        url: `/Intfinxx/availableToGenerateInvoice`,
        params,
        headers: { Modulecima: "Intfinxx" },
      }),
    }),
    getStatusInvoiceRefund: builder.query({
      query: (parameters) => ({
        url: `/Intfinxx/getStatusInvoiceRefund`,
        method: "GET",
        params: parameters,
        headers: { Modulecima: "Intfinxx" },
      }),
    }),
    getRefundsMassiveOperationRdo: builder.query({
      query: (params) => ({
        url: `Financix/Dosptefa/getMassiveRefundsOperations?per_page=15`,
        params,
      }),
    }),
    getPdfInvoiceRefund: builder.query({
      query: (parameters) => ({
        url: `/Intfinxx/getPdfInvoiceRefund`,
        method: "GET",
        params: parameters,
        headers: { Modulecima: "Intfinxx" },
      }),
    }),
    getTaskInvoicePending: builder.query({
      query: (params) => ({
        url: `Financix/Dosptefa/getTaskInvoicePending`,
        params,
      }),
    }),
    liquidateMassive: builder.mutation({
      query: (parameters) => ({
        url: `/Financix/Dosptefa/liquidateMassive`,
        method: "PUT",
        body: parameters,
      }),
      invalidatesTags: ["Create"],
    }),
    getInfoInvoicesOperatios: builder.query({
      query: (parameters) => ({
        url: `/Intfinxx/getInfoInvoicesOperatios`,
        method: "GET",
        params: parameters,
        headers: { Modulecima: "Intfinxx" },
      }),
    }),
    returnMassiveStatus: builder.mutation({
      query: (parameters) => ({
        url: `/Financix/Dosptefa/returnMassiveStatus`,
        method: "POST",
        body: parameters,
      }),
      invalidatesTags: ["Create"],
    }),
    sendInvoiceDian: builder.mutation({
      query: (parameters) => ({
        url: `/Intfinxx/sendInvoiceDian`,
        method: "POST",
        body: parameters,
        headers: { Modulecima: "Intfinxx" },
      }),
      invalidatesTags: ["Create"],
    }),
    sendSupportInvoice: builder.mutation({
      query: (parameters) => ({
        url: `/Intfinxx/sendSupportInvoice`,
        method: "POST",
        body: parameters,
        headers: { Modulecima: "Intfinxx" },
      }),
      invalidatesTags: ["Create"],
    }),
    retryInvoice: builder.mutation({
      query: (parameters) => ({
        url: `/Intfinxx/retryInvoice`,
        method: "POST",
        body: parameters,
        headers: { Modulecima: "Intfinxx" },
      }),
      invalidatesTags: ["Create"],
    }),
    getIsAutoritations: builder.query({
      query: (params) => ({
        url: `/Intfinxx/getAutoritations`,
        params,
        headers: { Modulecima: "Intfinxx" },
      }),
    }),
    manualFinancialClose: builder.mutation({
      query: (parameters) => ({
        url: `/Financix/Dosptefa/manualFinancialClose`,
        method: "POST",
        body: parameters,
        headers: { Modulecima: "Financix" },
      }),
      invalidatesTags: ["Create"],
    }),
    getErrorFacturaProforma: builder.query({
      query: (parameters) => ({
        url: `/Financix/Dosptefa/getErrorFacturaProforma`,
        method: "GET",
        params: parameters,
      }),
    }),
  }),
});

export const {
  useGetProjectsByClientMutation,
  useGetApplicableOfferQuery,
  useAssignProjectMutation,
  useLazyGetLiquidationDoQuery,
  useReturnStatusMutation,
  useGetConceptsByIdMutation,
  useStoreManualBillingMutation,
  useGetColorStatusQuery,
  useGetInvoiceProformaMutation,
  useWriteInvoiceMutation,
  useGetClientByPerfilDosptefaMutation,
  useLazyGetPreFilteredOperationsQuery,
  useGenerateDraftMutation,
  useGenerateBillingDocumentsMutation,
  useGetAdvanceClientMutation,
  useGetRefundsClientMutation,
  useGetInvoicesClientMutation,
  useGenerateExcelProformasMutation,
  useGetPdfInvoiceQuery,
  useLazyGetPdfInvoiceQuery,
  useGetProjectsByOperationsMutation,
  useGetRatesByOperationMutation,
  useLazyGetStatusInvoiceQuery,
  useLazyGetPreFilteredLevanteQuery,
  useGetOperationsByProformaQuery,
  useGetTotalAdvanceMutation,
  useGetDoGlobalByClientQuery,
  useGetTypeAdvanceClientQuery,
  useGetTaskAdvanceDoMutation,
  useGenerateDraftTaskMutation,
  useGetLiquidationsMutation,
  useLazyGetInformationBavariaQuery,
  useLazyGetBillingConditionQuery,
  useGenerateRefundIncomeDraftMutation,
  useGenerateRefundIncomeMutation,
  useLazyGetThirtsByOperationsQuery,
  useLazyGetStatusInvoiceRefundQuery,
  useLazyGetRefundsMassiveOperationRdoQuery,
  useGetPdfInvoiceRefundQuery,
  useLazyGetTaskInvoicePendingQuery,
  useLazyGetBillingClosureByIdQuery,
  useLiquidateMassiveMutation,
  useLazyGetIsAvailableToGenerateInvoiceQuery,
  useRejectProformaMutation,
  useLazyGetInfoInvoicesOperatiosQuery,
  useReturnMassiveStatusMutation,
  useLazyGetDoGlobalByClientQuery,
  useSendInvoiceDianMutation,
  useSendSupportInvoiceMutation,
  useRetryInvoiceMutation,
  useLazyGetIsAutoritationsQuery,
  useManualFinancialCloseMutation,
  useLazyGetErrorFacturaProformaQuery,
} = dosptefaApiSlice;
